import type { ReactNode } from 'react';

import { useAuth } from '@/auth/AuthProvider';

interface Props {
  perm?: string;
  children: ReactNode;
  fallback?: ReactNode;
}

export function PermissionGate({ perm, children, fallback = null }: Props) {
  const auth = useAuth();
  if (!perm) return <>{children}</>;
  return auth.hasPerm(perm) ? <>{children}</> : <>{fallback}</>;
}
